import React, { Component } from "react";
import { View } from "react-native";
import Text from "../../components_v2/TextFont";
import { connect } from "react-redux";
import * as DeviceTypes from "./_deviceTypes";
import * as faCharCodes from "../../../assets/consts/faCharCodes";

import PropTypes from "prop-types";

import { IconButton } from "../../components_v2/Buttons";
import ArTheme from "../../argon-ui/Theme";
import { getIsRTL } from "../../util";
class LightMeter extends Component {
  static propTypes = {
    deviceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    areaId: PropTypes.oneOfType([PropTypes.number]),
    areaUId: PropTypes.oneOfType([PropTypes.string]),
    style: PropTypes.any,
  };

  constructor(props) {
    super(props);
  }
  render() {
    let model = {},
      currentLux = undefined,
      unit = "lux";
    let { deviceId, areaId, areaUId } = this.props;
    if (deviceId) {
      model =
        this.props.DeviceReducer.list.find(
          (d) =>
            (d.deviceId == deviceId || d.deviceUId == deviceUId) &&
            d.deviceType == DeviceTypes.LIGHT_METER
        ) || {};
      if (model) {
        currentLux = model.value;
        unit = model.unit;
      }
    } else if (areaId || areaUId) {
      var area = this.props.AreaReducer.areas.find(
        (a) => a.areaId == areaId || a.areaUId == areaUId
      );
      if (area && area.devices) {
        var areaDevices = this.props.DeviceReducer.list

          .filter((d) => {
            if (
              d.deviceType == DeviceTypes.LIGHT_METER &&
              area.devices.indexOf(d.deviceId || d.deviceUId) >= 0
            ) {
              return true;
            }
          })
          .map((d) => {
            let { value, unit } = d;
            return { value, unit };
          });
        if (areaDevices.length > 0) {
          unit = areaDevices[0].unit;
          currentLux = 0;
          var validCount = areaDevices.length;
          for (var i in areaDevices) {
            var val = areaDevices[i].value;
            if (val == undefined || isNaN(val)) {
              validCount--;
              continue;
            }
            currentLux += val;
          }
          if (validCount > 0) {
            currentLux /= validCount;
            currentLux = Math.round(currentLux * 10) / 10;
          } else {
            currentLux = "-";
          }
        }
      }
    }

    if (currentLux == undefined || isNaN(currentLux)) {
      return null;
    }

    return (
      <View
        style={{
          ...this.props.style,
          flexDirection: getIsRTL() ? "row-reverse" : "row",
          alignItems: "center",
          height: 30,
        }}
      >
        {/* <FontAwesomeIcon icon={SelectedIcon} color={currentColor} size={28} /> */}
        <IconButton
          icon={{
            code: faCharCodes.faLightbulb, //"\uf8b8", // flashlight
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 18,
              color: "#ff990070",
              paddingHorizontal: 5,
              //transform: [{ rotate: "-90deg" }],
            },
          }}
        />
        <Text
          style={{
            //color: currentColor,
            fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
            fontSize: 18,
            marginHorizontal: 3,
          }}
        >
          {currentLux}
        </Text>
        <Text
          style={{
            //color: "#ccc",
            fontSize: 10,
            alignSelf: "baseline",
            paddingTop: 7,
            paddingStart: 3,
          }}
        >
          {unit}
        </Text>
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //localFucntion : (deviceId) => dispatch(Actions.ActionName(deviceId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LightMeter);
